export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  excerpt: string;
  content: string;
  imageUrl: string;
  author: string;
  date: string;
  views: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  imageUrl: string;
  count: number;
}

export const categories: Category[] = [
  {
    name: '明星黑料',
    slug: 'mingxing-heiliao',
    description: '最新明星八卦、娱乐圈黑料爆料，娱乐圈内幕消息一手掌握',
    imageUrl: 'https://readdy.ai/api/search-image?query=Red%20carpet%20celebrity%20event%20with%20paparazzi%20flashing%20cameras%2C%20dramatic%20lighting%2C%20glamorous%20atmosphere%2C%20mysterious%20dark%20background%2C%20cinematic%20moody%20photography%2C%20luxury%20evening%20gown%20scene%2C%20hollywood%20vibe%20with%20dark%20shadows%20and%20golden%20highlights&width=800&height=1067&seq=cat-mingxing-01&orientation=portrait',
    count: 128,
  },
  {
    name: '网红爆料',
    slug: 'wanghong-baoliao',
    description: '抖音快手网红八卦、直播圈内幕、网红私生活大揭秘',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20studio%20with%20smartphone%20live%20streaming%20setup%2C%20ring%20light%20glowing%20in%20dim%20room%2C%20social%20media%20influencer%20aesthetic%2C%20mysterious%20dramatic%20lighting%2C%20modern%20content%20creator%20workspace%2C%20deep%20shadows%20and%20warm%20accent%20lighting&width=800&height=1067&seq=cat-wanghong-02&orientation=portrait',
    count: 96,
  },
  {
    name: '社会热点',
    slug: 'shehui-redian',
    description: '社会热点事件追踪、争议人物曝光、最新爆料新闻汇总',
    imageUrl: 'https://readdy.ai/api/search-image?query=Urban%20night%20cityscape%20with%20breaking%20news%20vibe%2C%20dramatic%20dark%20street%20photography%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20moody%20atmosphere%2C%20cinematic%20noir%20style%2C%20mysterious%20city%20scene%20with%20deep%20contrast&width=800&height=1067&seq=cat-shehui-03&orientation=portrait',
    count: 85,
  },
  {
    name: '综艺吃瓜',
    slug: 'zongyi-chigua',
    description: '热门综艺节目幕后爆料、嘉宾争议事件追踪、选秀节目黑幕揭秘',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20stage%20with%20dramatic%20colorful%20lighting%2C%20empty%20game%20show%20set%2C%20behind%20the%20scenes%20atmosphere%2C%20cinematic%20dramatic%20mood%2C%20television%20studio%20with%20deep%20shadows%2C%20entertainment%20production%20scene&width=800&height=1067&seq=cat-zongyi-04&orientation=portrait',
    count: 72,
  },
];

export const articles: Article[] = [
  {
    id: '1',
    title: '某知名女星深夜私会神秘男子，酒店共度8小时全程曝光',
    slug: 'zhiming-nvxing-siwei-shenmi-nanzi',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    excerpt: '据知情人士透露，某一线女星近日被拍到与一位神秘男子深夜出入某五星级酒店，两人举止亲密，直到次日清晨才分别离开。',
    content: `<p>近日，娱乐圈再次掀起一场轩然大波。据一位不愿透露姓名的知情人士向本平台独家爆料，某当红一线女星在上周五深夜被目击与一位神秘男子共同进入北京某五星级酒店。</p><p>据现场目击者描述，当天晚上约11点30分，该女星一身黑色休闲装扮，戴着口罩和棒球帽，低调现身酒店地下停车场。随后，一位身材高大的男子从一辆黑色商务车上下来，两人迅速进入电梯。</p><p>"他们看起来非常熟悉，男子还自然地搂着她的腰，"目击者回忆道，"虽然她包裹得很严实，但从身形和走路的姿态，一眼就能认出是她。"</p><p>更令人震惊的是，两人在酒店共处了整整8个小时，直到次日早上7点40分左右才分别离开。女星先行乘坐保姆车离开，而男子则在半小时后才独自驾车离开酒店。</p><p>该女星此前一直以清纯形象示人，在公开场合多次表示自己单身，专注事业。此次事件曝光后，粉丝们纷纷表示震惊和失望。有网友扒出该男子疑似是某投资公司的高管，两人此前曾在一场慈善晚宴上有过交集。</p><p>截至目前，该女星方面尚未对此事作出任何回应。本平台将持续跟踪报道。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%20with%20dramatic%20moody%20lighting%2C%20paparazzi%20style%20photography%2C%20mysterious%20atmosphere%2C%20dark%20elegant%20setting%2C%20cinematic%20noir%20aesthetic%2C%20shadowy%20figures%20entering%20exclusive%20venue%2C%20warm%20golden%20lights%20contrasting%20deep%20shadows&width=1600&height=900&seq=article-01-main&orientation=landscape',
    author: '黑料君',
    date: '2026-07-07',
    views: 285600,
    tags: ['女星', '酒店', '私会', '爆料'],
    isHot: true,
    isNew: true,
  },
  {
    id: '2',
    title: '千万粉丝网红直播翻车，真实素颜震惊全网观众',
    slug: 'qianwan-fensi-wanghong-zhibo-fanche',
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    excerpt: '拥有千万粉丝的知名网红在直播中意外关闭美颜滤镜，真实面貌与平日精修照片形成鲜明对比，引发网友热议。',
    content: `<p>昨天晚间，一场意外让拥有1200万粉丝的知名网红"甜心小鹿"陷入了前所未有的舆论危机。在例行直播过程中，因为手机系统更新导致美颜软件意外关闭，这位网红真实的容貌毫无保留地展现在了数百万在线观众面前。</p><p>直播画面中，没有了美颜滤镜加持的她，与平时社交平台上展示的精修照片判若两人。皮肤状态、脸型轮廓都与粉丝印象中的形象有着明显差异。</p><p>弹幕瞬间炸开了锅，"这是同一个人吗？"、"我关注了三年的女神居然是……"、"美颜果然是21世纪最伟大的发明"等评论刷屏了整个直播间。</p><p>意识到问题后，"甜心小鹿"面色慌张地中断了直播，但为时已晚——已经有大量网友截图并在各大社交平台疯传。话题#网红直播翻车#迅速登上热搜榜首，阅读量在短短两小时内突破3亿。</p><p>事后，"甜心小鹿"在微博发文道歉，称"每个人都有不完美的一面，希望大家能够理解"。但这条微博下的评论区依旧两极分化严重，支持者认为"网红也是普通人"，反对者则指责其"长期欺骗粉丝"。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20live%20streaming%20screen%20with%20dramatic%20glitch%20effect%2C%20dark%20room%20with%20ring%20light%2C%20digital%20distortion%20aesthetic%2C%20moody%20tech%20noir%20atmosphere%2C%20streaming%20setup%20in%20dim%20lighting%2C%20cyber%20mysterious%20vibe&width=1600&height=900&seq=article-02-main&orientation=landscape',
    author: '吃瓜一线',
    date: '2026-07-06',
    views: 421000,
    tags: ['网红', '直播', '美颜', '翻车'],
    isHot: true,
    isNew: false,
  },
  {
    id: '3',
    title: '某综艺节目录制现场爆发激烈冲突，导演组紧急叫停',
    slug: 'zongyi-jiemu-chongtu-jiaoting',
    category: '综艺吃瓜',
    categorySlug: 'zongyi-chigua',
    excerpt: '国内某热门综艺节目在最新一期录制过程中，两位嘉宾因游戏环节发生口角进而演变为肢体冲突，节目组被迫中断录制。',
    content: `<p>据现场工作人员透露，国内某卫视热门综艺节目在昨日录制最新一期节目时发生了一起严重的冲突事件。两位固定嘉宾在游戏环节中因为意见不合爆发激烈争吵，随后演变为推搡。</p><p>事件发生在下午3点左右，当时正在进行一个团队对抗游戏环节。据目击者称，嘉宾A认为嘉宾B在游戏中作弊，当场发飙，摔掉了手中的道具麦克风。嘉宾B不甘示弱，回怼了几句，两人随即发生口角。</p><p>"现场气氛瞬间降到了冰点，"一位现场观众回忆道，"大家都懵了，没想到会发生这种事。后来两人越吵越凶，甚至互相推搡起来，导演组赶紧冲上去把他们拉开。"</p><p>节目总导演随即宣布暂停录制，所有嘉宾被送回各自的休息室。据内部人士透露，节目组正在紧急商讨此事如何处理，本期节目的播出时间可能会受到影响。</p><p>这档节目此前一直以"和谐欢乐"的形象示人，此次冲突事件无疑给节目蒙上了一层阴影。有网友评论："这才是真正的综艺，没有剧本的那种。"也有观众担忧节目会因此停播。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20red%20and%20blue%20stage%20lighting%2C%20empty%20game%20show%20stage%2C%20tense%20atmosphere%2C%20broadcasting%20equipment%20scattered%2C%20cinematic%20dramatic%20lighting%2C%20dark%20moody%20television%20studio%20scene&width=1600&height=900&seq=article-03-main&orientation=landscape',
    author: '综艺观察员',
    date: '2026-07-06',
    views: 198300,
    tags: ['综艺', '冲突', '录制', '嘉宾'],
    isHot: true,
    isNew: false,
  },
  {
    id: '4',
    title: '知名企业家被曝婚内出轨，小三身份疑似圈内女艺人',
    slug: 'qiyejia-hunnei-chugui',
    category: '社会热点',
    categorySlug: 'shehui-redian',
    excerpt: '某知名科技公司创始人被爆料长期婚内出轨，出轨对象被指是娱乐圈某三线女艺人，两人在多个场合被拍到亲密同行。',
    content: `<p>近日，一则关于某知名科技公司创始人的爆料在网络上持续发酵。据多位知情人士透露，这位身价数十亿的企业家长期维持着一段婚外情关系，而出轨对象竟然是一位圈内的三线女艺人。</p><p>根据爆料者提供的线索，两人最早在去年的一场慈善拍卖会上相识，随后关系迅速升温。在过去的一年里，有人多次目击两人在国内外多个城市同游，包括东京、巴黎和马尔代夫等地。</p><p>"他们非常谨慎，但纸终究包不住火，"一位接近当事人的消息人士表示，"企业家给她在朝阳区买了一套价值3000多万的豪宅，还投资了她主演的一部网剧。"</p><p>这位企业家的妻子是大学时期的恋人，两人育有一对子女。消息传出后，其妻子的社交媒体账号已经设置了私密。而那位被指为"小三"的女艺人的经纪公司则发表声明称"纯属恶意造谣，将保留追究法律责任的权利"。</p><p>这起事件再次引发了公众对名人婚姻和道德底线的讨论。有网友评论道："有钱真的可以为所欲为吗？"也有人表示："在真相水落石出之前，不要急着站队。"</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20mansion%20at%20dusk%20with%20dramatic%20sky%2C%20mysterious%20wealthy%20lifestyle%20scene%2C%20modern%20architecture%20with%20dark%20atmosphere%2C%20cinematic%20noir%20photography%2C%20exclusive%20residential%20area%20with%20deep%20shadows%20and%20warm%20window%20lights&width=1600&height=900&seq=article-04-main&orientation=landscape',
    author: '财经八卦哥',
    date: '2026-07-05',
    views: 356700,
    tags: ['企业家', '出轨', '女艺人', '婚外情'],
    isHot: false,
    isNew: false,
  },
  {
    id: '5',
    title: '顶流男团成员私下抽烟喝酒蹦迪，人设彻底崩塌',
    slug: 'dingliu-nantuan-renshe-bengta',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    excerpt: '以阳光少年形象走红的某男团成员被粉丝拍到在夜店通宵狂欢，大量不雅照片视频流出，经纪公司紧急公关。',
    content: `<p>一向以"阳光少年"、"正能量偶像"形象示人的某顶流男团成员，近日因为一组夜店照片和视频的流出而人设崩塌。这些影像资料显示，这位平时在镜头前文质彬彬的偶像，私下里却是一个抽烟、喝酒、蹦迪的"老手"。</p><p>据提供照片的网友称，这组照片拍摄于上周六凌晨的上海某知名夜店。画面中，该男团成员与几名友人坐在VIP卡座，桌上摆满了各种酒水。他手持香烟，吞云吐雾，姿态娴熟，与平日里的阳光形象判若两人。</p><p>另一段视频则显示他在舞池中与多名女性贴身热舞，动作大胆，完全不是那个在舞台上羞涩微笑的少年。</p><p>这些影像资料一经曝光，立刻在粉丝圈中引发轩然大波。大批粉丝表示"无法接受"、"感觉被欺骗了"。该男团的官方粉丝群在短时间内流失了近30%的成员。</p><p>面对危机，经纪公司火速发表声明，称这些照片"系恶意剪辑和恶意拍摄"，并强调该艺人"一直遵守职业道德，保持健康的生活方式"。但网友们显然并不买账，评论区充斥着质疑和嘲讽。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Nightclub%20interior%20with%20dramatic%20purple%20and%20red%20neon%20lighting%2C%20empty%20dance%20floor%20with%20laser%20effects%2C%20dark%20atmosphere%2C%20VIP%20section%20with%20bottle%20service%2C%20cinematic%20night%20life%20photography%2C%20moody%20club%20scene&width=1600&height=900&seq=article-05-main&orientation=landscape',
    author: '饭圈观察员',
    date: '2026-07-05',
    views: 512000,
    tags: ['男团', '夜店', '人设', '崩了'],
    isHot: true,
    isNew: false,
  },
  {
    id: '6',
    title: '知名女主播被曝拖欠员工工资，公司内部聊天记录流出',
    slug: 'zhubo-tuoqian-gongzi',
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    excerpt: '某平台知名女主播被前员工实名举报，称其长期拖欠员工工资和社保，内部聊天记录显示其态度恶劣。',
    content: `<p>一位自称是某知名女主播公司前员工的网友，近日在社交媒体上发布长文，实名举报该女主播长期拖欠员工工资、克扣社保，并附上了多张内部聊天记录截图作为证据。</p><p>根据该前员工的描述，他在该公司工作了一年零三个月，期间女主播多次以"公司资金周转困难"为由，延迟发放工资，有时甚至拖欠两三个月。更令人寒心的是，公司从未为员工缴纳社保和公积金。</p><p>曝光的聊天记录显示，当员工在群里询问工资发放时间时，该女主播回复："急什么急，又不是不发，公司也有公司的难处，不想干可以走。"语气之强硬令网友震惊。</p><p>此事迅速登上热搜，许多网友涌到该女主播的社交账号下留言讨伐。有网友扒出该女主播平时的炫富动态——豪车、名表、奢侈品，与拖欠员工工资的行为形成刺眼对比。</p><p>截至目前，该女主播尚未对此事作出任何正面回应，但其社交账号的评论区已被关闭。市场监管部门表示已关注到相关投诉，将依法依规进行调查。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20modern%20office%20with%20computer%20screens%20glowing%2C%20empty%20workspace%20at%20night%2C%20tense%20corporate%20atmosphere%2C%20dramatic%20shadows%2C%20cinematic%20lighting%2C%20abandoned%20desk%20with%20scattered%20documents%2C%20moody%20professional%20setting&width=1600&height=900&seq=article-06-main&orientation=landscape',
    author: '劳动权益哥',
    date: '2026-07-04',
    views: 189500,
    tags: ['主播', '工资', '员工', '举报'],
    isHot: false,
    isNew: false,
  },
  {
    id: '7',
    title: '某选秀节目冠军被曝学历造假，学信网查无此人',
    slug: 'xuanxiu-guanjun-xueli-zaojia',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    excerpt: '去年某大型选秀节目的冠军选手被网友扒出学历造假，其声称的某知名高校学历在学信网上查询不到任何记录。',
    content: `<p>又一位选秀明星陷入学历造假风波。去年在某大型选秀节目中夺冠并成功出道的选手林某，被热心网友发现其多次在公开场合提到的"某某大学本科毕业"学历可能存在问题。</p><p>事情的起因是一位网友在观看林某的粉丝见面会视频时，注意到他在回答学历相关问题时言辞闪烁，于是抱着好奇的心态去学信网进行了查询。结果发现，在学信网的数据库中确实查询不到他的任何学历信息。</p><p>该网友将查询过程录制成视频发布到网上后，迅速引发了更多网友的验证。大家纷纷尝试在不同方式下进行查询，结果一致——查无此人。</p><p>更有网友翻出林某此前参加选秀节目时的自我介绍视频，其中他明确表示自己是"某某大学新闻传播学院本科毕业"。如果学历确系造假，这无疑是对观众和粉丝的严重欺骗。</p><p>面对愈演愈烈的舆论，林某的经纪公司发布声明称"林某确实在该校学习过，可能因为一些学籍问题导致系统中暂时无法查询到，正在与学校方面积极沟通解决"。但这个解释并没有平息网友的质疑。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=University%20campus%20at%20twilight%20with%20dramatic%20sky%2C%20empty%20graduation%20stage%2C%20diploma%20and%20certificate%20on%20dark%20background%2C%20mysterious%20academic%20scene%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20contemplative%20education%20theme&width=1600&height=900&seq=article-07-main&orientation=landscape',
    author: '学历打假人',
    date: '2026-07-04',
    views: 278000,
    tags: ['选秀', '学历', '造假', '冠军'],
    isHot: false,
    isNew: false,
  },
  {
    id: '8',
    title: '某知名导演潜规则女演员录音曝光，多名女星牵涉其中',
    slug: 'daoyan-qian-guize-luyin',
    category: '综艺吃瓜',
    categorySlug: 'zongyi-chigua',
    excerpt: '一段据称是某知名导演与女演员的私下通话录音在网络上疯传，录音内容涉及"潜规则"暗示，引发轩然大波。',
    content: `<p>今日，一段时长约3分钟的录音在各大社交平台疯传。录音中，一个被指认为某知名导演的男声与一名年轻女声进行对话，男声中多次出现"只要你配合"、"这个角色就是你的"、"晚上来我房间讨论剧本"等暗示性话语。</p><p>这段录音据称是由一位不愿透露姓名的圈内人士提供的。录音中的男声被网友通过声纹分析后，高度疑似是曾执导过多部热门影视剧的某导演。而女声据推测是一位刚入行不久的新人女演员。</p><p>录音中，男声说："这个行业就是这样，你想要好的资源，总得付出点什么。我在这行二十年了，捧红了多少人，你应该清楚。"女声则显得犹豫和不安，多次用"我再想想"来回避。</p><p>此录音一出，立刻在娱乐圈投下了一颗重磅炸弹。多位曾与该导演合作过的女演员也被网友扒出，怀疑她们是否也曾遭遇类似情况。一时间，网络上掀起了"反潜规则"的声浪。</p><p>截至目前，该导演方面尚未作出任何回应。而据知情人士透露，其所在的影视公司正在紧急商讨应对方案。多位法律界人士表示，如果录音内容属实，涉事导演可能面临严重的法律后果。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20set%20director%20chair%20empty%20under%20dramatic%20spotlight%2C%20dark%20cinema%20studio%20atmosphere%2C%20mysterious%20movie%20production%20scene%2C%20cinematic%20noir%20photography%2C%20behind%20the%20scenes%20with%20deep%20shadows%2C%20film%20equipment%20in%20moody%20lighting&width=1600&height=900&seq=article-08-main&orientation=landscape',
    author: '圈内老鬼',
    date: '2026-07-03',
    views: 689000,
    tags: ['导演', '潜规则', '录音', '女演员'],
    isHot: true,
    isNew: false,
  },
  {
    id: '9',
    title: '某女团成员与经纪公司解约内幕：遭不公平对待长达三年',
    slug: 'nvtuan-jieyue-neimu',
    category: '明星黑料',
    categorySlug: 'mingxing-heiliao',
    excerpt: '女团成员通过律师发表声明，揭露经纪公司长期克扣收入、强制过度工作等不公平待遇，引发行业震动。',
    content: `<p>今日上午，某当红女团成员通过律师发表了一份长达五页的声明，详细揭露了其与经纪公司签约三年来的种种不公平待遇。这份声明以数据说话，列出了多项触目惊心的内容。</p><p>根据声明，该公司在过去三年中，从该成员的演艺收入中抽取了高达80%的分成，远超行业平均水平。此外，公司还要求她每天工作超过16个小时，全年无休，导致她多次因过度疲劳被送医治疗。</p><p>"公司规定我们必须住在公司安排的宿舍，不允许私自外出，"声明中写道，"我们的手机被公司统一管理，社交账号的密码也在经纪人手中，我们完全没有任何个人自由。"</p><p>更令人震惊的是，声明还提到公司曾在成员生病时拒绝提供医疗救助，要求她们"坚持完成演出"。一次该成员高烧39度，仍然被迫上台表演，最终在后台晕倒。</p><p>这封声明的发布引发了整个娱乐行业的震动。多位娱乐圈人士公开声援该成员，呼吁行业改革。某知名艺人协会发表声明称，将对涉事公司展开调查。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Empty%20dance%20practice%20room%20with%20mirrors%20at%20night%2C%20dark%20atmosphere%2C%20single%20spotlight%20on%20floor%2C%20dramatic%20shadows%2C%20abandoned%20performance%20space%2C%20cinematic%20moody%20lighting%2C%20contemplative%20kpop%20training%20room&width=1600&height=900&seq=article-09-main&orientation=landscape',
    author: '娱乐正义联盟',
    date: '2026-07-03',
    views: 345000,
    tags: ['女团', '解约', '不公平', '经纪公司'],
    isHot: false,
    isNew: false,
  },
  {
    id: '10',
    title: '知名美食博主被曝食材造假，精致摆拍背后全是套路',
    slug: 'meishi-bozhu-shicai-zaojia',
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    excerpt: '拥有500万粉丝的美食博主被同行曝光，其视频中使用的"高级食材"实际是廉价替代品，拍摄现场的真相令人大跌眼镜。',
    content: `<p>美食圈今天炸锅了。一位拥有500万粉丝的知名美食博主被另一位同行博主在直播中意外"踢爆"，其视频中展示的各种"高级进口食材"，实际上都是廉价的替代品。</p><p>事件的起因是两位博主在同一家进口超市偶遇。当时这位知名博主正在拍摄新一期"米其林级家庭料理"的视频，对着镜头介绍手中的"日本A5和牛"。然而，据目击的同行博主描述，购物车里的商品标签显示，那不过是普通的国产牛肉。</p><p>"我就站在他旁边，清清楚楚看到标签上的价格和产地，"爆料的同行博主在直播中说，"他拿起来对着镜头说是3000块一斤的和牛，但标签上明明写着68块一斤。我当时真的无语了。"</p><p>此事曝光后，网友们纷纷开始翻看该博主过往的视频，发现了更多的"疑点"。比如他曾经展示的"法国鹅肝"被怀疑是鸭肝，"意大利松露"被怀疑是普通香菇切片。一时间，#美食博主造假#成为热门话题。</p><p>面对铺天盖地质疑，该博主发布了一段道歉视频，承认"为了追求视觉效果，在食材展示方面做了不实描述"，但辩称"做出来的味道是一样的"。这个解释显然无法让粉丝信服。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20kitchen%20set%20with%20dramatic%20lighting%2C%20food%20photography%20behind%20the%20scenes%2C%20camera%20equipment%20surrounding%20plated%20dish%2C%20moody%20cinematic%20atmosphere%2C%20professional%20studio%20kitchen%20with%20deep%20shadows%2C%20artificial%20food%20styling%20setup&width=1600&height=900&seq=article-10-main&orientation=landscape',
    author: '真吃真评',
    date: '2026-07-02',
    views: 234000,
    tags: ['美食', '博主', '造假', '食材'],
    isHot: false,
    isNew: false,
  },
  {
    id: '11',
    title: '某影视公司老板涉嫌洗钱被带走调查，多位明星紧急切割',
    slug: 'yingshi-laoban-xiqian',
    category: '社会热点',
    categorySlug: 'shehui-redian',
    excerpt: '某知名影视投资公司实际控制人因涉嫌洗钱被警方带走，公司旗下多位签约艺人火速发布声明划清界限。',
    content: `<p>今日上午，据可靠消息，某知名影视投资公司的实际控制人张某因涉嫌洗钱罪被警方带走协助调查。该公司近年来投资了多部票房过亿的影视作品，在业内具有较大的影响力。</p><p>据悉，此次调查与一起跨国洗钱案有关。警方在调查中发现，张某通过影视投资项目作为掩护，将大量非法资金"洗白"。其操作手法包括虚报制作成本、虚构海外发行收入等。</p><p>消息传出后，该公司旗下签约的多位知名演员和导演火速通过工作室发布声明，宣布已与该公司解除合作关系，并强调"对于公司的违法行为毫不知情"。这种紧急切割的做法引发了网友的嘲讽，有人调侃"昨天还是好伙伴，今天就是陌生人"。</p><p>据业内人士分析，此案可能牵涉甚广。有消息称，除了洗钱之外，调查还涉及偷税漏税、虚假注资等问题。如果罪名成立，张某可能面临十年以上的有期徒刑。</p><p>此次事件对整个影视行业造成了不小的震动。多位投资方已暂停与该公司的合作项目，多个正在筹备中的影视剧面临停摆风险。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20building%20at%20night%20with%20police%20lights%2C%20dramatic%20crime%20scene%20atmosphere%2C%20modern%20skyscraper%20with%20reflection%2C%20cinematic%20noir%20style%2C%20investigation%20scene%20with%20moody%20lighting%2C%20financial%20district%20in%20shadows&width=1600&height=900&seq=article-11-main&orientation=landscape',
    author: '法制观察',
    date: '2026-07-02',
    views: 401000,
    tags: ['洗钱', '影视', '老板', '调查'],
    isHot: true,
    isNew: false,
  },
  {
    id: '12',
    title: '某说唱歌手新歌涉嫌抄袭，原曲作者跨国维权',
    slug: 'shuochang-geshou-chaoxi',
    category: '综艺吃瓜',
    categorySlug: 'zongyi-chigua',
    excerpt: '国内某当红说唱歌手新发布的单曲被指旋律和歌词高度雷同某韩国歌曲，原曲作者已委托律师发起跨国维权。',
    content: `<p>近日，国内某当红说唱歌手最新发布的单曲《XXX》陷入了抄袭争议。多名音乐人和网友指出，这首歌的副歌旋律与某韩国说唱歌手去年发布的歌曲几乎一模一样，甚至连部分中文歌词都是韩文原词的"直译"。</p><p>音乐博主"节奏实验室"制作了一段对比视频，将两首歌曲的波形图并排展示，相似度惊人。视频中，两首歌在同一段落的旋律走向、节奏型分布和编曲结构几乎完全重合。</p><p>"这不是致敬，这是赤裸裸的抄袭，"该博主在视频中评论道，"从旋律到flow，从编曲到歌词，相似度超过90%——如果这都不算抄袭，我不知道什么才算。"</p><p>事件发酵后，韩国原曲的版权方迅速作出反应。据悉，原曲作者已委托中国的律师事务所发起了跨国维权，要求该说唱歌手立即下架歌曲并赔偿经济损失。</p><p>面对指控，该说唱歌手在微博发文回应："音乐没有国界，好的作品可以互相借鉴。我承认受到了那首歌的启发，但绝对不是抄袭。"但这个回应被网友讥讽为"教科书般的狡辩"。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Recording%20studio%20with%20dramatic%20red%20and%20blue%20lighting%2C%20microphone%20on%20stand%20in%20center%2C%20dark%20atmosphere%2C%20music%20production%20equipment%2C%20cinematic%20mood%2C%20empty%20studio%20with%20deep%20shadows%2C%20professional%20audio%20setup&width=1600&height=900&seq=article-12-main&orientation=landscape',
    author: '音乐警察',
    date: '2026-07-01',
    views: 167000,
    tags: ['说唱', '抄袭', '维权', '歌曲'],
    isHot: false,
    isNew: false,
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.categorySlug === categorySlug);
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};

export const getHotArticles = (): Article[] => {
  return articles.filter((a) => a.isHot);
};

export const getLatestArticles = (count: number = 8): Article[] => {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, count);
};

export const getRelatedArticles = (currentId: string, count: number = 4): Article[] => {
  const current = articles.find((a) => a.id === currentId);
  if (!current) return [];
  return articles
    .filter((a) => a.id !== currentId && a.categorySlug === current.categorySlug)
    .slice(0, count);
};